import {Injectable} from '@angular/core';
import {UserContextService} from '../../../core/services/user-context.service';
import {QueryKamContactRequestModel} from '../models/query-kam-contact-reques.model';
import {QueryKamContactResponseModel} from '../models/query-kam-contact-response.model';
import {IProjectsContactService} from './projects-contact.service.interface';
import {ContactService} from '../../contact-widget/services/contact.service';
import {IContact} from '../../contact-widget/interfaces/contact.interface';

@Injectable()
export class ProjectsContactsWidgetService {

    public projectContact: IContact;

    constructor(
        private userContextService: UserContextService,
        private contactService: ContactService,
        private projectsContactService: IProjectsContactService
    ) {
    }

    public async getWidgetContactList(): Promise<{ contact: IContact, isRelatedContact: boolean }[]> {

        let result: { contact: IContact, isRelatedContact: boolean }[] = [];
        if (this.projectContact) {
            result = [{contact: this.projectContact, isRelatedContact: false}];
        }
        const relatedContactEmail: string = this.userContextService.getRelatedContactEmail();

        const contact = await this.contactService.get(this.userContextService.getUserId(), relatedContactEmail);


        if (contact) {
            result.push({contact: contact, isRelatedContact: true});
        }
        return result;
    }

    public async refreshProjectKamContact(request: QueryKamContactRequestModel): Promise<void> {
        const response: QueryKamContactResponseModel = await this.projectsContactService.queryKamContact(request);
        this.projectContact = response.projectKamContact;
    }

}
